module.exports = __webpack_public_path__ + "images/category_lp/watch_samples/q01_2_pc_375a597b74cae250b27d8a1188337a38.png";